import React from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';

export default function AddToHome() {
    return (
        <>
            <Helmet>
                <title>Add To Home</title>
            </Helmet>
            <div className="min-h-screen gradient-bg-1 p-4 pb-24 md:pb-6 md:p-6">
                {/* start: add-to-home page */}
                <div className="min-h-screen gradient-bg-1 flex flex-col items-center justify-center p-6">
                    <div className="max-w-sm w-full" style={{ opacity: 1, transform: "none" }}>
                        <div className="bg-card rounded-3xl shadow-2xl p-8 text-center">
                            <div className="w-20 h-20 bg-primary/10 rounded-3xl flex items-center justify-center mx-auto mb-6">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-smartphone w-10 h-10 text-primary"
                                >
                                    <rect width={14} height={20} x={5} y={2} rx={2} ry={2} />
                                    <path d="M12 18h.01" />
                                </svg>
                            </div>
                            <h2 className="text-2xl font-bold text-foreground mb-4">
                                Add to Home Screen
                            </h2>
                            <p className="text-foreground/70 mb-8">
                                Get quick access to Reya anytime by adding Syntimacy to your home screen
                            </p>
                            <button className="inline-flex items-center justify-center gap-2 whitespace-nowrap ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 hover:bg-primary/90 h-10 bg-primary text-primary-foreground hover:opacity-90 rounded-full px-8 py-6 text-lg font-semibold shadow-lg transition-all duration-300 hover:shadow-xl hover:scale-105 w-full">
                                Got it
                            </button>
                        </div>
                    </div>
                </div>
                {/* end: add-to-home page */}
            </div>

        </>
    );
}

